import React, { Component } from "react";
import "./PlanSuggestionOfferItem.css";

class PlanSuggestionOfferItem extends Component {
  constructor(props) {
    super(props);
  }

  getUrl() {
    const {
      urlTc,
      urlEn,
      campaignCode,
      funSharePack,
      videoStreaming,
    } = this.props.offer;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    var url = lang === "tc" ? urlTc : urlEn;

    url += `&defCC=${campaignCode}`;

    if (funSharePack) {
      url += "&defCNMO=enable";
    }

    if (videoStreaming) {
      url += "&defSocial=enable";
    }

    return `${url}`;
  }

  getPlanImageFilePath() {
    const { campaignCode, funSharePack, videoStreaming } = this.props.offer;
    var fileName = campaignCode;
    if (funSharePack) {
      fileName += "-funSharePack";
    }

    if (videoStreaming) {
      fileName += "-videoStreaming";
    }

    const lang = window.THREE_REACT_APP_GLOBAL.language === "tc" ? "tc" : "en";
    return `/assets/images/planImages/${fileName}-${lang}.png`;
  }

  render() {
    const imageFilePath = this.getPlanImageFilePath();
    const url = this.getUrl();
    return (
      <a
        href={url}
        role="button"
        target="_blank"
        className="plan-suggestion-offer-card-link"
      >
        <img
          class={`plan-suggestion-offer-card-img`}
          src={`${imageFilePath}`}
        />
      </a>
    );
  }
}

export default PlanSuggestionOfferItem;
